/**
 * @author taulmax
 * @date 2024.10.07
 * @description CS 페이지
 */
const CS = () => {
  return <>CS 페이지에요</>;
};

export default CS;
